import React from "react";
import ManageAuthenticationView from "./ManageAuthenticationView";

const ManageAuthentication = () => {
  return <ManageAuthenticationView />;
};

export default ManageAuthentication;
